export default __webpack_public_path__ + "static/media/organisation-icon.4ed9759f.svg";